import { jotaiStore } from '@shared/store/jotai/jotai-store';
import { dcbAtom } from '@shared/store/slice-atoms';
import { UAE_LG_AG26, UAE_ST_AG26 } from '@shared/config/constants/api-sources';

export const REFERRER_SS_NAME = 'referrerURL';
export const LG_AG26_FLAG = 'lg_ag26Variation';
export const ST_AG26_FLAG = 'st_ag26Variation';

const FUNNEL_SEGMENTS = new Set(['confirm-pin', 'thankyou']);

type Ag26Slug = 'lg_ag26' | 'st_ag26';

const persist = (slug: Ag26Slug) => {
  try {
    if (slug === 'lg_ag26') {
      sessionStorage.setItem(LG_AG26_FLAG, '1');
      sessionStorage.removeItem(ST_AG26_FLAG);
    } else {
      sessionStorage.setItem(ST_AG26_FLAG, '1');
      sessionStorage.removeItem(LG_AG26_FLAG);
    }
  } catch {
    // private mode / quota
  }
};

export const clearAg26VariationFlags = () => {
  try {
    sessionStorage.removeItem(LG_AG26_FLAG);
    sessionStorage.removeItem(ST_AG26_FLAG);
  } catch {
    // private mode / quota
  }
};

const getPathFirstSegment = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.pathname.split('/').filter(Boolean)[0] || '';
};

/**
 * Resolves `lg_ag26` / `st_ag26` only. Any other landing slug clears the
 * session flags so OTP/thank-you chrome cannot leak onto other variations.
 */
export const resolveAg26Variation = (slug: Ag26Slug): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const first = getPathFirstSegment();
  const other: Ag26Slug = slug === 'lg_ag26' ? 'st_ag26' : 'lg_ag26';
  const flag = slug === 'lg_ag26' ? LG_AG26_FLAG : ST_AG26_FLAG;
  const apiSource = slug === 'lg_ag26' ? UAE_LG_AG26 : UAE_ST_AG26;

  if (first === slug) {
    persist(slug);
    return true;
  }

  if (first === other) {
    return false;
  }

  if (first && !FUNNEL_SEGMENTS.has(first)) {
    clearAg26VariationFlags();
    return false;
  }

  try {
    const referrer = sessionStorage.getItem(REFERRER_SS_NAME);
    if (referrer) {
      if (referrer.includes(`/${slug}`)) {
        persist(slug);
        return true;
      }

      return false;
    }

    if (sessionStorage.getItem(flag) === '1') {
      return true;
    }
  } catch {
    // private mode
  }

  try {
    const source = jotaiStore.get(dcbAtom)?.homeData?.source;
    if (source === apiSource) {
      persist(slug);
      return true;
    }
  } catch {
    // jotai store not ready — ignore
  }

  return false;
};
